import jsonHelper from "../../shared/jsonHelper";
import statusHelper from "./projectStore_calcStatusHelper";
import * as statuses from "./projectStore_Constants";

export default {
  state: {
    projects: {},
    ActiveProjectModality: 0,
    currentProject: "",
    calcStep: "",
    calcStatus: "",
    actions: [],
    status_NonConfigurato: false,
    status_PreCalcolo: false,
    status_PostCalcolo: false,
    status_Verifica: false,
    status_Selezione: false,
    status_Anteprima: false,
    status_Warning: false,
    status_ArrivoDaSelezione: false,
    status_ImpedisciSelezione: false,
    spalla: null,
    disableCalcolate: false,
    bDisableNextDaSpalla: false,
    projectsWindows: [], // MARCO DC 25/08/2021
    fluidsDictionary: {},
    umsDictionary: {}
  },
  getters: {
    projects: state => state.projects,
    projectsWindows: state => state.projectsWindows, // MARCO DC 25/08/2021
    getProjectModality: state => state.ActiveProjectModality,
    calcStep: state => state.calcStep,
    calcStatus: state => state.calcStatus,
    status_NonConfigurato: state => state.status_NonConfigurato,
    status_PreCalcolo: state => state.status_PreCalcolo,
    status_PostCalcolo: state => state.status_PostCalcolo,
    status_Verifica: state => state.status_Verifica,
    status_Selezione: state => state.status_Selezione,
    status_Anteprima: state => state.status_Anteprima,
    status_Warning: state => state.status_Warning,
    status_ArrivoDaSelezione: state => state.status_ArrivoDaSelezione,
    status_ImpedisciSelezione: state => state.status_ImpedisciSelezione,
    spalla: state => state.spalla,
    disableCalcolate: state => state.disableCalcolate,
    bDisableNextDaSpalla: state => state.bDisableNextDaSpalla,
    fluidsDictionary: state => state.fluidsDictionary,
    umsDictionary: state => state.umsDictionary
  },
  mutations: {
    resetProgetti(state) {
      state.projects = {};
    },
    disabiltaCalcola(state) {
      console.log("disabiltaCalcola");
      state.disableCalcolate = true;
    },
    abilitaCalcola(state) {
      console.log("abilitaCalcola");
      state.disableCalcolate = false;
    },
    bDisableNextDaSpalla(state, value) {
      console.log("bDisableNextDaSpalla");
      state.bDisableNextDaSpalla = value;
    },
    fluidsDictionary(state, value) {
      console.log("fluidsDictionary");
      state.fluidsDictionary = value;
    },
    umsDictionary(state, value) {
      console.log("umsDictionary");
      state.umsDictionary = value;
    },
    refreshStatus(state) {
      if (state.projects && state.currentProject) {
        state.calcStep = state.projects[state.currentProject].calcStep;
        state.calcStatus = state.projects[state.currentProject].calcStatus;
        state.status_NonConfigurato = statusHelper.checkForStatus(
          state.projects[state.currentProject].calcStatus,
          statuses.NON_CONFIGURATO
        );
        state.status_PreCalcolo = statusHelper.checkForStatus(
          state.projects[state.currentProject].calcStatus,
          statuses.PRE_CALCOLO
        );
        state.status_PostCalcolo = statusHelper.checkForStatus(
          state.projects[state.currentProject].calcStatus,
          statuses.POST_CALCOLO
        );
        state.status_Verifica = statusHelper.checkForStatus(
          state.projects[state.currentProject].calcStatus,
          statuses.VERIFICA
        );
        state.status_Selezione = statusHelper.checkForStatus(
          state.projects[state.currentProject].calcStatus,
          statuses.SELEZIONE
        );
        state.status_Anteprima = statusHelper.checkForStatus(
          state.projects[state.currentProject].calcStatus,
          statuses.ANTEPRIMA
        );
        state.status_Warning = statusHelper.checkForStatus(
          state.projects[state.currentProject].calcStatus,
          statuses.WARNING
        );
        state.status_ArrivoDaSelezione = statusHelper.checkForStatus(
          state.projects[state.currentProject].calcStatus,
          statuses.ARRIVO_DA_SELEZIONE
        );
        state.status_ImpedisciSelezione = statusHelper.checkForStatus(
          state.projects[state.currentProject].calcStatus,
          statuses.IMPEDISCI_SELEZIONE
        );
      }
    },
    ensureStatus(state, newStatus) {
      let actionsList = [];
      state.projects[state.currentProject].calcStatus = statusHelper.ensureStatus(
        state.projects[state.currentProject].calcStatus,
        newStatus,
        actionsList
      );
      //if (actionsList && actionsList.length) alert(JSON.stringify(actionsList));
      state.actions = actionsList;
    },
    changeProjectPropertyInternal(state, payload) {
      jsonHelper.setProperty(state.projects, payload.path, payload.value);
    },
    changeProjectProperty(state, payload) {
      if (payload.path.includes(".shoulder.designTemperature")) {
        console.log(payload.value);
      }

      jsonHelper.setProperty(state.projects, payload.path, payload.value);
    },
    userInputChanged(state, payload) {},
    loadProject(state, payload) {
      if (payload != null) {
        if (payload.projectId != null) {
          state.projects = {};
          state.projects[payload.projectId] = payload.project;
          state.currentProject = payload.projectId;
        }
      }
    },
    removeProject(state, prjId) {
      if (state.currentProject == prjId) {
        state.currentProject = "";
      }
      delete state.projects[prjId];
    },
    updateUnidato(state, payload) {
      jsonHelper.setProperty(state.projects, `${payload.path}.input`, payload.unidato.input);
      jsonHelper.setProperty(state.projects, `${payload.path}.output`, payload.unidato.output);
      jsonHelper.setProperty(
        state.projects,
        `${payload.path}.outputBilancio`,
        payload.unidato.outputBilancio
      );
      jsonHelper.setProperty(
        state.projects,
        `${payload.path}.userInputValueDbl`,
        payload.unidato.input.usrValue.value
      );
    },
    refreshSelectionDblClick() {},
    refreshSettaScambiatoreDadCodice() {},
    refreshAll() {},
    refreshAllData() {},
    refreshFluid() {},
    // refreshWarnings() {},
    changeActiveProjectModalityProperty(state, modality) {
      state.ActiveProjectModality = modality;
      console.log(">>> changeActiveProjectModalityProperty = " + modality);
    },
    clearCurrentProject(state, projectId) {
      if (state.currentProject == projectId) {
        state.currentProject = "";
      }
      const prj = state.projects[projectId];
      if (prj) {
        const prjInfo = {
          name: prj.name,
          modality: prj.modality,
          projectId: prj.projectId
        };
        state.projects[projectId] = prjInfo;
      }
    },
    changeShoulderStateProperty(state, value) {
      state.shoulderState = value;
      console.log(">>> changeShoulderStateProperty = " + value);
    },
    refreshFormInput(state, data) {
      console.log(">>> refreshFormInput = " + data);
    },
    backToSelectionPostCalculate(state, data) {
      console.log(">>> backToSelectionPostCalculate = " + data);
    },
    refreshSelectionOutputFromBack() {
      console.log(">>> refreshSelectionOutputFromBack");
    },
    changingShoulder(state, data) {
      console.log(">>> changingShoulder = " + data);
    },
    changedShoulder(state, data) {
      console.log(">>> changedShoulder = " + data);
    },
    resetInputForms(state) {
      if (!state.status_ArrivoDaSelezione) {
        let modality = state.projects[state.currentProject].modality;

        statusHelper.settaOutputAndBalanceToNull(
          state.projects,
          state.currentProject,
          "top.totalCapacity"
        );
        statusHelper.settaOutputAndBalanceToNull(
          state.projects,
          state.currentProject,
          "top.totalOversizing"
        );
        statusHelper.settaOutputAndBalanceToNull(
          state.projects,
          state.currentProject,
          "top.heatTransfertArea"
        );
        statusHelper.settaOutputAndBalanceToNull(
          state.projects,
          state.currentProject,
          "top.globalFactor"
        );
        statusHelper.settaOutputAndBalanceToNull(state.projects, state.currentProject, "top.lmtd");
        statusHelper.settaOutputAndBalanceToNull(
          state.projects,
          state.currentProject,
          "top.foulingFactor"
        );
        statusHelper.settaOutputAndBalanceToNull(state.projects, state.currentProject, "top.delta");

        // Primary Side
        statusHelper.settaOutputAndBalanceToNull(state.projects, state.currentProject, "left.flow");
        statusHelper.settaOutputAndBalanceToNull(
          state.projects,
          state.currentProject,
          "left.inletTemperature"
        );
        statusHelper.settaOutputAndBalanceToNull(
          state.projects,
          state.currentProject,
          "left.outletTemperature"
        );
        statusHelper.settaOutputAndBalanceToNull(
          state.projects,
          state.currentProject,
          "left.pressureDrop"
        );
        statusHelper.settaOutputAndBalanceToNull(
          state.projects,
          state.currentProject,
          "left.fluidVelocity"
        );
        statusHelper.settaOutputAndBalanceToNull(
          state.projects,
          state.currentProject,
          "left.pressureDropConnections"
        );
        statusHelper.settaOutputAndBalanceToNull(
          state.projects,
          state.currentProject,
          "left.fluidVelocityConnections"
        );
        statusHelper.settaOutputAndBalanceToNull(
          state.projects,
          state.currentProject,
          "left.fluidVelocityChannel"
        );
        statusHelper.settaOutputAndBalanceToNull(
          state.projects,
          state.currentProject,
          "left.reynolds"
        );
        statusHelper.settaOutputAndBalanceToNull(
          state.projects,
          state.currentProject,
          "left.heatTransferCoefficient"
        );
        statusHelper.settaOutputAndBalanceToNull(
          state.projects,
          state.currentProject,
          "left.shearIndex"
        );

        // fluid-fluid
        if (modality == 8) {
          // Secondary Side
          statusHelper.settaOutputAndBalanceToNull(
            state.projects,
            state.currentProject,
            "right.flow"
          );
          statusHelper.settaOutputAndBalanceToNull(
            state.projects,
            state.currentProject,
            "right.inletTemperature"
          );
          statusHelper.settaOutputAndBalanceToNull(
            state.projects,
            state.currentProject,
            "right.outletTemperature"
          );
          statusHelper.settaOutputAndBalanceToNull(
            state.projects,
            state.currentProject,
            "right.pressureDrop"
          );
          statusHelper.settaOutputAndBalanceToNull(
            state.projects,
            state.currentProject,
            "right.fluidVelocity"
          );
          statusHelper.settaOutputAndBalanceToNull(
            state.projects,
            state.currentProject,
            "right.pressureDropConnections"
          );
          statusHelper.settaOutputAndBalanceToNull(
            state.projects,
            state.currentProject,
            "right.fluidVelocityConnections"
          );
          statusHelper.settaOutputAndBalanceToNull(
            state.projects,
            state.currentProject,
            "right.fluidVelocityChannel"
          );
          statusHelper.settaOutputAndBalanceToNull(
            state.projects,
            state.currentProject,
            "right.reynolds"
          );
          statusHelper.settaOutputAndBalanceToNull(
            state.projects,
            state.currentProject,
            "right.heatTransferCoefficient"
          );
          statusHelper.settaOutputAndBalanceToNull(
            state.projects,
            state.currentProject,
            "right.shearIndex"
          );
        }

        // vapore
        if (modality == 11) {
          statusHelper.settaOutputAndBalanceToNull(
            state.projects,
            state.currentProject,
            "right.flow"
          );
          statusHelper.settaOutputAndBalanceToNull(
            state.projects,
            state.currentProject,
            "right.pressureDrop"
          );
          statusHelper.settaOutputAndBalanceToNull(
            state.projects,
            state.currentProject,
            "right.fluidVelocityGasPhase"
          );
          statusHelper.settaOutputAndBalanceToNull(
            state.projects,
            state.currentProject,
            "right.fluidVelocityLiquidPhase"
          );
        }
      }
    },
    impostaDatiModelloDaSelezione(state, val) {
      statusHelper.settaValore(
        state.projects,
        state.currentProject,
        "bottom.numberOfPlates",
        val.numeroDiPiastre,
        true,
        true,
        true
      );
      statusHelper.settaValore(
        state.projects,
        state.currentProject,
        "bottom.numberOfCircuitsPrimarySide",
        val.numberOfCircuitsPrimario,
        true,
        true,
        true
      );
      statusHelper.settaValore(
        state.projects,
        state.currentProject,
        "bottom.numberOfCircuitsSecondarySide",
        val.numberOfCircuitsSecondario,
        true,
        true,
        true
      );
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "bottom.highPerformancePlatePercentageValue",
        val.percentualeAltaResa
      );
      statusHelper.settaValoreView(
        this,
        state.projects,
        state.currentProject,
        "left.outletTemperature",
        val.toutPrimario,
        false,
        true,
        false
      );
      statusHelper.settaValoreView(
        this,
        state.projects,
        state.currentProject,
        "left.pressureDrop",
        val.perditeDiCaricoTotaliPrimario,
        false,
        true,
        false
      );
      statusHelper.settaValoreView(
        this,
        state.projects,
        state.currentProject,
        "right.outletTemperature",
        val.toutSecondario,
        false,
        true,
        false
      );
      statusHelper.settaValoreView(
        this,
        state.projects,
        state.currentProject,
        "right.pressureDrop",
        val.perditeDiCaricoTotaliSecondario,
        false,
        true,
        false
      );
      statusHelper.settaValore(
        state.projects,
        state.currentProject,
        "top.delta",
        val.delta,
        false,
        true,
        false
      );
      statusHelper.settaValoreView(
        this,
        state.projects,
        state.currentProject,
        "top.totalCapacity",
        val.potenza,
        false,
        true,
        false
      );
    },
    impostaDatiSpallaDaSelezione(state, val) {
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idCalculationModeValue",
        val.idCalculationModeValue
      );
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idTypeOfPheValue",
        val.idTypeOfPheValue
      );
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idDesignStandardValue",
        val.idDesignStandardValue
      );
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idProductLineValue",
        val.idProductLineValue
      );
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idDesignPressureValue",
        val.idDesignPressureValue
      );
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idPlatesMaterialValue",
        val.idPlatesMaterialValue
      );
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idGasketsMaterialValue",
        val.idGasketsMaterialValue
      );
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idFramesMaterialValue",
        val.idFramesMaterialValue
      );
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idPlatesThickness",
        val.idPlatesThickness
      );
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idSizeGeometry",
        val.idSizeGeometry
      );
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idTypeGeometry",
        val.idTypeGeometry
      );
    },
    ripristinaStatoSpalla(state) {
      let val = state.spalla;
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idCalculationTypeValue",
        val.idCalculationTypeValue
      );
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idCalculationModeValue",
        val.idCalculationModeValue
      );
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idTypeOfPheValue",
        val.idTypeOfPheValue
      );
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idDesignStandardValue",
        val.idDesignStandardValue
      );
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idProductLineValue",
        val.idProductLineValue
      );
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idDesignPressureValue",
        val.idDesignPressureValue
      );
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idPlatesMaterialValue",
        val.idPlatesMaterialValue
      );
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idGasketsMaterialValue",
        val.idGasketsMaterialValue
      );
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idFramesMaterialValue",
        val.idFramesMaterialValue
      );
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idPlatesThickness",
        val.idPlatesThickness
      );
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idSizeGeometry",
        val.idSizeGeometry
      );
      statusHelper.settaValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idTypeGeometry",
        val.idTypeGeometry
      );
    },
    salvaStatoSpalla(state) {
      state.spalla = {};
      state.spalla.idCalculationTypeValue = 1;
      state.spalla.idCalculationModeValue = statusHelper.leggiValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idCalculationMode"
      );
      state.spalla.idTypeOfPheValue = statusHelper.leggiValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idTypeOfPhe"
      );
      state.spalla.idDesignStandardValue = statusHelper.leggiValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idDesignStandard"
      );
      state.spalla.idProductLineValue = statusHelper.leggiValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idProductLine"
      );
      state.spalla.idDesignPressureValue = statusHelper.leggiValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idDesignPressure"
      );
      state.spalla.idPlatesMaterialValue = statusHelper.leggiValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idPlatesMaterial"
      );
      state.spalla.idGasketsMaterialValue = statusHelper.leggiValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idGasketsMaterial"
      );
      state.spalla.idFramesMaterialValue = statusHelper.leggiValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idFramesMaterial"
      );
      state.spalla.idPlatesThickness = statusHelper.leggiValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idPlatesThickness"
      );
      state.spalla.idSizeGeometry = statusHelper.leggiValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idSizeGeometry"
      );
      state.spalla.idTypeGeometry = statusHelper.leggiValoreDiretto(
        state.projects,
        state.currentProject,
        "shoulder.idTypeGeometry"
      );
    }
  },
  actions: {
    loadFluidsDictionary({ commit }, payload) {
      commit("fluidsDictionary", payload);
    },
    loadUmsDictionary({ commit }, payload) {
      commit("umsDictionary", payload);
    },
    changeProjectProperty({ commit }, payload) {
      commit("changeProjectProperty", payload);
    },
    userInputChanged({ commit }, payload) {
      commit("userInputChanged", payload);
    },
    changeProjectPropertyInternal({ commit }, payload) {
      commit("changeProjectPropertyInternal", payload);
    },
    loadProject({ commit }, payload) {
      commit("removeProject", payload.projectId); // name
      commit("loadProject", payload);
      commit("refreshStatus");
    },
    removeProject({ commit }, prjName) {
      commit("removeProject", prjName);
      commit("refreshStatus");
    },
    updateUnidato({ commit }, payload) {
      commit("updateUnidato", payload);
    },
    refreshSelectionDblClick({ commit }) {
      commit("refreshSelectionDblClick");
    },
    refreshSettaScambiatoreDadCodice({ commit }) {
      commit("refreshSettaScambiatoreDadCodice");
    },
    refreshAll({ commit }) {
      commit("refreshAll");
      commit("refreshStatus");
    },
    refreshAllData({ commit }) {
      commit("refreshAllData");
    },
    refreshFormInput({ commit }, data) {
      commit("refreshFormInput", data);
    },
    backToSelectionPostCalculate({ commit }, data) {
      commit("backToSelectionPostCalculate", data);
    },
    changingShoulder({ commit }, data) {
      commit("changingShoulder", data);
    },
    changedShoulder({ commit }, data) {
      commit("changedShoulder", data);
    },
    refreshSelectionOutputFromBack({ commit }) {
      commit("refreshSelectionOutputFromBack");
    },
    refreshFluid({ commit }) {
      commit("refreshFluid");
    },
    /* refreshWarnings({ commit }) {
      commit("refreshWarnings");
    }, */
    changeActiveProjectModalityProperty({ commit }, modality) {
      commit("changeActiveProjectModalityProperty", modality);
    },
    clearCurrentProject({ commit }, projectId) {
      setTimeout(() => {
        commit("clearCurrentProject", projectId);
      }, 3000);
    },
    changeShoulderStateProperty({ commit }, value) {
      commit("changeShoulderStateProperty", value);
    },

    ensureStatus({ commit, state }, newStatus) {
      commit("ensureStatus", newStatus);
      commit("refreshStatus");
      if (state.actions && state.actions.length) {
        state.actions.forEach(itm => {
          commit("" + itm);
        });
        state.actions = [];
      }
    },

    impostaDatiModelloDaSelezione({ commit }, value) {
      commit("impostaDatiModelloDaSelezione", value);
      commit("refreshAll");
    },

    impostaDatiSpallaDaSelezione({ commit }, value) {
      commit("impostaDatiSpallaDaSelezione", value);
      commit("refreshAll");
    },

    ripristinaStatoSpalla({ commit }, value) {
      commit("ripristinaStatoSpalla", value);
      commit("refreshAll");
    }
  }
};
